// extracted by mini-css-extract-plugin
export default {"unitEvidenceAlertContainer":"CardContainer__unitEvidenceAlertContainer___Fkhwi"};